const availabilityRoutes = {
  availability: {
    path: '/availabilities'
  }
};

export default availabilityRoutes;
